import React from "react";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";
import { formatPrice } from "../util";
import qs from "qs";

import config from "../config";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";
import UserStore from "../stores/UserStore";
import DownloadPassBucketCsvButton from "./partials/download-pass-bucket-csv-button.jsx";

import WorkingIndicator from "./partials/working-indicator.jsx";

class PassBuckets extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForPassBucket = this._makeRowForPassBucket.bind(this);
  }

  static getStores() {
    return [PassBucketStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketsForEventBucket:
        PassBucketStore.getPassBucketsForEventBucket,
      isFetching: PassBucketStore.getState().isFetching,
      apiKey: UserStore.getState().apiKey
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeRowForPassBucket(passBucket) {
    return (
      <Tr key={passBucket.id}>
        <Td column="Name" value={passBucket.name}>
          {passBucket.name}
        </Td>
        <Td column="Code" value={passBucket.code}>
          {passBucket.code}
        </Td>
        <Td column="Price" value={passBucket.price}>
          {formatPrice(passBucket.price || 0)}
        </Td>
        <Td column="Passes Issued" value={passBucket.price}>
          {passBucket.unlimited
            ? `${passBucket.quantity_sold}/∞`
            : `${passBucket.quantity_sold}/${passBucket.quantity}`}
        </Td>
        {UserStore.hasPermission("view_pass_bucket") ||
        UserStore.hasPermission("edit_pass_bucket") ? (
          <Td column="Actions">
            <div>
              <Link
                to={{
                  pathname: `/event_buckets/${this.props.params.eventBucketId}/pass_buckets/${passBucket.id}`,
                  state: { fromListing: true }
                }}
              >
                {UserStore.hasPermission("edit_pass_bucket")
                  ? "View"
                  : "View Uses"}
              </Link>
              &nbsp;
              {UserStore.hasPermission("edit_pass_bucket") ||
              UserStore.hasPermission("view_pass_bucket_rules") ? (
                <Link
                  to={{
                    pathname: UserStore.hasPermission("edit_pass_bucket")
                      ? `/event_buckets/${this.props.params.eventBucketId}/pass_buckets/${passBucket.id}/edit`
                      : `/event_buckets/${this.props.params.eventBucketId}/pass_buckets/${passBucket.id}/edit/pass_rules`,
                    state: { fromListing: true }
                  }}
                >
                  {UserStore.hasPermission("edit_pass_bucket")
                    ? "Edit"
                    : "View Rules"}
                </Link>
              ) : null}
            </div>
          </Td>
        ) : null}
      </Tr>
    );
  }

  componentWillMount() {
    PassBucketActions.fetchAllForEventBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      passBuckets = this.props.getPassBucketsForEventBucket(
        this.props.params.eventBucketId
      ),
      rows = passBuckets.map(this._makeRowForPassBucket);

    if (passBuckets.length === 0 && PassBucketStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={[
            { column: "Name", sortFunction: Sort.CaseInsensitive },
            "Code",
            "Price"
          ]}
          defaultSort={{ column: "Name", direction: "asc" }}
          columns={["Name", "Code", "Price", "Passes Issued"].concat(
            UserStore.hasPermission("view_pass_bucket") ||
              UserStore.hasPermission("edit_pass_bucket")
              ? ["Actions"]
              : []
          )}
          filterable={["Name", "Code"]}
          filterPlaceholder="Type to filter..."
        >
          {rows}
        </Table>
        {rows.length === 0 && UserStore.hasPermission("edit_pass_bucket") ? (
          <div className="empty-table-message">
            No pass buckets yet.{" "}
            <Link
              to={`/event_buckets/${this.props.params.eventBucketId}/pass_buckets/new`}
            >
              Create a new pass bucket.
            </Link>
          </div>
        ) : null}
        {UserStore.hasPermission("edit_pass_bucket") ? (
          <div style={{ marginTop: 20 }}>
            <RaisedButton
              label="Create new pass bucket"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${this.props.params.eventBucketId}/pass_buckets/new`
                )
              }
            />
            <DownloadPassBucketCsvButton
              style={{ marginLeft: 7, verticalAlign: "top" }}
              label="Download all passes (.csv)"
              eventBucketId={this.props.params.eventBucketId}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(PassBuckets);



// WEBPACK FOOTER //
// ./src/app/components/pass-buckets.jsx